<!-- 汉听报名页 -->
<template>
  <div class="container">
    <div class="banner">
      <img src="https://market-cdn.anoah.com/dm/static/market-h5-clue/bg/old_change_new_form_bg.png" />
    </div>
    <div class="bottom">
      <div class="form">
        <van-cell-group>
          <van-field label="手机号" v-model.trim="phone" label-width="50" :required="true" type="tel" placeholder="请输入"
            @blur.native.capture="phoneValidateAction" :error-message="phoneValidate" :maxlength="11">
          </van-field>
        </van-cell-group>
        <div :class="{ 'apply-btn': true, 'disabled': !phone }" @click="apply">
          <van-loading v-if="loading" size="16px" type="spinner" color="#242424" style="margin-right: 7px;" />
          报名预约
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isEmpty } from "lodash/fp";
import { sendPhoneVerifyCode } from '@/axios/applyForm/oldChangeNew';
const validPhone = (phone) => /^1[3-9]\d{9}$/.test(phone);
const sourceMap = {
  1: '公众号',
  2: '家管',
  3: '平板',
  4: '短信',
};
export default {
  data() {
    return {
      phone: '',
      phoneValidate: '',
      showResult: true,
      loading: false,
      onShowTime: 0,
      trackData: { pageId: 990010, pageName: '以旧换新活动详情' },
    };
  },
  mounted() {
    this.onShowTime = (new Date).getTime();
    const { source } = this.$route.query;
    const fromChannelName = sourceMap[source] || '';
    this.$set(this.trackData, 'fromChannelName', fromChannelName);
    this.$set(this.trackData, 'fromChannelId', source);
    yjhx.track('PAGE_EXPOSE', { ...this.trackData, fromChannelName, fromChannelId: source });
  },
  destroyed() {
    const onHideTime = (new Date).getTime();
    yjhx.track('PAGE_EXIT', {
      ...this.trackData,
      duration: onHideTime - this.onShowTime > 0 ? onHideTime - this.onShowTime : 0,
    });
  },
  methods: {
    phoneValidateAction() {
      if (
        isEmpty(this.phone) || !validPhone(this.phone)
      ) {
        this.phoneValidate = "请输入正确的手机号";
      } else {
        this.phoneValidate = "";
      }
    },
    // 点击报名
    apply() {
      yjhx.track('BUTTON_CLICK', {
        ...this.trackData,
        buttonName: '报名',
        buttonContent: this.phone
      });
      this.phoneValidateAction();
      if (this.phoneValidate || this.loading) {
        return;
      }
      console.log(this.phone, '开始报名')
      this.loading = true;
      sendPhoneVerifyCode({ mobile: this.phone, ...this.$route.query }).then(res => {
        this.loading = false;
        if (res.errcode === 0) {
          sessionStorage.setItem('oldChangeNew-guideInfo', JSON.stringify(res.data || {}));
          sessionStorage.setItem('oldChangeNew-user-phone', this.phone || '');
          this.$router.push({
            path: '/oldChangeNewDetail',
            query: { ...this.$route.query, mobile: this.phone, redirectUrl: decodeURIComponent(location.href) }
          });
        } else {
          this.$toast(res.errmsg);
        }
      }).catch((err) => {
        this.$toast('网络错误，请稍后重试');
        this.loading = false;
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .banner {
    width: 100%;
    flex: 1;
    overflow-y: scroll;
    padding-right: 27px;

    &::-webkit-scrollbar {
      display: none;
    }

    img {
      width: 100%;
    }
  }

  .bottom {
    padding-top: 3px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    padding-bottom: constant(safe-area-inset-bottom);
    /* 兼容 iOS < 11.2 */
    padding-bottom: env(safe-area-inset-bottom);
    /* 兼容 iOS >= 11.2 */
  }

  .form {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    padding-top: 0;

    /deep/.van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
      border: 0;
    }

    /deep/.van-cell {
      padding: 25px 16px;
      border-bottom: 1px solid rgba($color: #CECECE, $alpha: 0.3);

      input {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
      }

      .van-cell__title {
        span {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
        }
      }

      .van-field__error-message {
        position: absolute;
      }
    }

    .apply-btn {
      width: 100%;
      height: 44px;
      background: #FFD451;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      margin-top: 20px;

      &.disabled {
        color: #666666;
        background: #E9E9ED;
      }
    }
  }
}
</style>
